<ion-app>
	<ion-router-outlet>
		<div class="loader">
			<span class="loader-inner"></span>
		</div>
	</ion-router-outlet>
	<ion-toast
		[isOpen]="toastState().isOpen"
		[message]="toastState().message"
		[duration]="toastState().duration"
		[color]="toastState().color"
		[position]="toastState().position"
		[buttons]="toastState().buttons"
		[icon]="toastState().icon"
		[cssClass]="toastState().cssClass"
		[translucent]="toastState().translucent"
		[keyboardClose]="toastState().keyboardClose"
		(didDismiss)="dismissToast()"
	></ion-toast>
</ion-app>